/**
 * Test EPUB Files Configuration
 *
 * Each set points to an exploded (unzipped) EPUB directory inside src/dev-content-files/epub/.
 * Readium's PlainResourceFetcher loads them directly from disk.
 */

const testEpubFiles = {
    simple: {
        name: 'Simple EPUB Sample',
        path: 'dev-content-files/epub/epub_sample',
        cover: 'dev-content-files/epub_cover.jpeg',
        description: 'Basic EPUB for fundamental testing',
    },

    spanish: {
        name: 'El Mago de Oz',
        path: 'dev-content-files/epub/el-mago-de-oz',
        description: 'Spanish language - El Mago de Oz',
    },

    chinese: {
        name: 'Legend of the Dragon Boat Festival',
        path: 'dev-content-files/epub/dragon-boat-festival',
        description: 'Chinese language - Dragon Boat Festival',
    },

    english: {
        name: "Alice's Adventures in Wonderland",
        path: 'dev-content-files/epub/alice-in-wonderland',
        description: 'English - Classic novel',
    },

    'fixed-layout': {
        name: 'Fixed Layout Sample',
        path: 'dev-content-files/epub/fixed-layout-sample',
        description: 'Pre-paginated - three fixed pages',
    },

    'large-figures': {
        name: 'Large figures',
        path: 'dev-content-files/epub/large-figures',
        description:
            'One figure per chapter at 12, 48 and 100 megapixels, and the 48 MP one inside an SVG: memory and sharpness of the image viewer, iOS in particular',
    },
};

export function getTestEpubFile() {
    const epubSet = new URLSearchParams(window.location.search).get('epub_set') || 'simple';
    return testEpubFiles[epubSet] || testEpubFiles.simple;
}

export default testEpubFiles;
